export default "__VITE_ASSET__CU6ZfQ1h__"